import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { AnimatedStats } from '../components/AnimatedStats';
import { Benefits } from '../components/Benefits';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { WhatsAppFloat } from '../components/WhatsAppFloat';

export const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <AnimatedStats />
      <Benefits />
      <Pricing />
      <FAQ />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default Home;
